import { ReactElement, useCallback, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonBatchManagementCrumbs } from '../constants';
import FormFunction, { BatchManagementForm } from 'system/components/batch-management/form';
import { useParams, useNavigate } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __OPERATION__BATCH__ } from 'shell/constants/environment';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { Job } from 'shell/models/job-item';
import { requestTransformerBatchManagement } from '../utils/submit-request-transformer';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { transformerJob } from '../utils/transformer-job';

const BatchManagementEdit = (): ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const editJob = useHttpClient(`${__OPERATION__BATCH__}/jobs/`, { options: { method: 'PUT' } });

  const [job] = useHttpFetch<HttpResponse<Job>, BatchManagementForm>(
    `${__OPERATION__BATCH__}/jobs/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: transformerJob,
    }
  );

  const onOk = useCallback(
    (form: BatchManagementForm) => {
      const updateData = requestTransformerBatchManagement(form);
      (
        editJob({
          data: updateData,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/gestione-batch');
      });
    },
    [editJob]
  );

  const content = useMemo(() => {
    return job.pristine || job.isLoading || job.hasErrors ? null : (
      <FormFunction
        title="Modifica Batch"
        onOk={onOk}
        onCancel={() => {
          navigate('/sistema/gestione-batch');
        }}
        initialValues={job.data as BatchManagementForm}
      />
    );
  }, [navigate, job, onOk]);

  return (
    <>
      <Breadcrumbs items={[...CommonBatchManagementCrumbs, { name: 'Modifica Batch' }]} />
      {content}
    </>
  );
};

BatchManagementEdit.displayName = 'Batch Management Edit';

export default BatchManagementEdit;
